import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';

const Footer = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <>
      <style>{`
        .footer-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 56px 24px 40px;
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: 48px;
        }
        .footer-bottom {
          border-top: 1px solid rgba(255,255,255,0.08);
          padding: 20px 24px;
          max-width: 1280px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
        }
        .footer-col-title {
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.1em;
          color: #CC0000;
          text-transform: uppercase;
          padding-bottom: 8px;
          border-bottom: 1px solid rgba(204,0,0,0.25);
          margin: 0 0 6px 0;
        }
        .footer-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 0;
          margin: 0;
        }
        .footer-link {
          color: rgba(255,255,255,0.65);
          font-size: 14px;
          text-decoration: none;
        }
        .footer-contact-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding: 0;
          margin: 0;
        }
        .footer-contact-list li {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: rgba(255,255,255,0.75);
          font-size: 13px;
          line-height: 1.5;
        }
        .footer-contact-icon {
          font-size: 14px;
          flex-shrink: 0;
          margin-top: 1px;
        }
        .footer-email-link {
          transition: color 0.15s;
          color: rgba(255,255,255,0.65);
          font-size: 13px;
          text-decoration: none;
          word-break: break-all;
        }
        .footer-email-link:hover {
          color: #CC0000;
        }
        .footer-socials {
          display: flex;
          gap: 10px;
          margin-top: 4px;
          flex-wrap: wrap;
        }
        .footer-social-btn {
          padding: 8px 16px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 600;
          color: #ffffff;
          background: rgba(204,0,0,0.25);
          border: 1px solid rgba(204,0,0,0.4);
          text-decoration: none;
        }

        @media (max-width: 768px) {
          .footer-container {
            grid-template-columns: 1fr 1fr !important;
            gap: 32px 20px !important;
            padding: 36px 16px 28px !important;
          }
          .footer-brand {
            grid-column: 1 / -1;
          }
        }

        @media (max-width: 480px) {
          .footer-container {
            grid-template-columns: 1fr !important;
            gap: 28px !important;
            padding: 28px 16px !important;
          }
          .footer-brand {
            grid-column: 1 !important;
          }
          .footer-bottom {
            flex-direction: column;
            text-align: center;
            padding: 16px;
          }
        }
      `}</style>

      <footer style={styles.footer(theme)}>
        {/* Top accent line */}
        <div style={styles.accentLine} />

        <div className="footer-container">
          {/* Brand */}
          <div className="footer-brand" style={styles.brand}>
            <img src="/techdave-logo.png" alt="Techdave Solutions" style={styles.logoImg} />
            <h3 style={styles.brandName}>TECHDAVE SOLUTIONS</h3>
            <p style={styles.tagline}>
              Harare's trusted technology partner. Quality products,
              expert service, competitive prices.
            </p>
            <div className="footer-socials">
              <a href="https://wa.me/263772758875" className="footer-social-btn" target="_blank" rel="noopener noreferrer">
                WhatsApp
              </a>
              <a href="mailto:sales@techdavesolutions.co.zw" className="footer-social-btn">Sales</a>
              <a href="mailto:info@techdavesolutions.co.zw" className="footer-social-btn">Info</a>
            </div>
          </div>

          {/* Quick Links */}
          <div style={styles.col}>
            <h4 className="footer-col-title">Quick Links</h4>
            <ul className="footer-list">
              {['Home', 'Shop', 'Services', 'About', 'Contact'].map((page) => (
                <li key={page}>
                  <Link to={`/${page === 'Home' ? '' : page.toLowerCase()}`} className="footer-link">
                    {page}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div style={styles.col}>
            <h4 className="footer-col-title">Products</h4>
            <ul className="footer-list">
              {['Laptops', 'Desktops', 'Smartphones', 'Printers', 'PA Systems', 'Networking', 'Accessories', 'Laptop Bags'].map((p) => (
                <li key={p}>
                  <Link to={`/shop?category=${p.toLowerCase().replace(' ', '-')}`} className="footer-link">
                    {p}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div style={styles.col}>
            <h4 className="footer-col-title">Contact Us</h4>
            <ul className="footer-contact-list">
              <li>
                <span className="footer-contact-icon">📍</span>
                <span>B30 Eastgate Market, Harare, Zimbabwe</span>
              </li>
              <li>
                <span className="footer-contact-icon">📞</span>
                <a href="https://wa.me/263772758875" style={{color:"rgba(255,255,255,0.75)",textDecoration:"none"}}>+263 772 758 875</a>
              </li>
              <li>
                <span className="footer-contact-icon">📞</span>
                <a href="https://wa.me/263785661758" style={{color:"rgba(255,255,255,0.75)",textDecoration:"none"}}>+263 785 661 758</a>
              </li>
              <li>
                <span className="footer-contact-icon">✉️</span>
                <a href="mailto:sales@techdavesolutions.co.zw" className="footer-email-link">
                  sales@techdavesolutions.co.zw
                </a>
              </li>
              <li>
                <span className="footer-contact-icon">✉️</span>
                <a href="mailto:info@techdavesolutions.co.zw" className="footer-email-link">
                  info@techdavesolutions.co.zw
                </a>
              </li>
              <li>
                <span className="footer-contact-icon">🕐</span>
                <span>Mon–Sat: 8AM – 5PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p style={styles.copyright}>© {new Date().getFullYear()} Techdave Solutions. All rights reserved.</p>
          <p style={styles.copyright}>Proudly serving Harare 🇿🇼</p>
        </div>
      </footer>
    </>
  );
};

const styles = {
  footer: (theme) => ({
    backgroundColor: theme === 'dark' ? '#0d0d0d' : '#1a1a1a',
    color: '#ffffff',
    marginTop: 'auto',
  }),
  accentLine: {
    height: '4px',
    background: 'linear-gradient(90deg, #CC0000, #FF4444, #CC0000)',
  },
  brand: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
  logoImg: {
    height: '48px',
    width: 'auto',
    filter: 'brightness(0) invert(1)',
    opacity: 0.9,
  },
  brandName: {
    fontSize: '16px',
    fontWeight: '800',
    color: '#CC0000',
    letterSpacing: '0.05em',
    margin: 0,
  },
  tagline: {
    fontSize: '14px',
    lineHeight: 1.6,
    color: 'rgba(255,255,255,0.6)',
    maxWidth: '280px',
    margin: 0,
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
  copyright: {
    fontSize: '13px',
    color: 'rgba(255,255,255,0.45)',
    margin: 0,
  },
};

export default Footer;
